const Card = ({ title, children }) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-lg shadow-lg
                border border-[#E6CCB2] overflow-hidden
                transition-all duration-300 ease-in-out
                hover:shadow-xl hover:border-[#B85C38]
                group">
      {title && (
        <div className="px-6 py-4 border-b border-[#E6CCB2]
                    bg-gradient-to-r from-[#E6CCB2] to-[#F2D0A9]
                    group-hover:from-[#B85C38] group-hover:to-[#E6CCB2]
                    transition-all duration-300">
          <h3 className="text-lg font-semibold text-[#2E1F27]">{title}</h3>
        </div>
      )}
      <div className="p-6">{children}</div>
    </div>
  );
};

export default Card;